import axiosClient from '@/core/axiosClient'
import { toJSONDate } from '@/core/utils'
import { DietReport, ReportWeekSummary, SicknessReport, TimeReport, TransportReport } from '@/models/report.model'
const resource = 'api/report'

export default {
  async getTimeReportWeekOverview (weekNumber: number, year: number) {
    return await axiosClient.get(`${resource}/time/week/?weekNumber=${weekNumber}&year=${year}`)
  },
  async getTransportReportWeekOverview (weekNumber: number, year: number) {
    return await axiosClient.get(`${resource}/transport/week/?weekNumber=${weekNumber}&year=${year}`)
  },
  async getSicknessReportWeekOverview (weekNumber: number, year: number) {
    return await axiosClient.get(`${resource}/sickness/week/?weekNumber=${weekNumber}&year=${year}`)
  },
  async getTimeReportDetails (date: Date) {
    return await axiosClient.get(`${resource}/time?date=${toJSONDate(date)}`)
  },
  async getTransportReportDetails (date: Date) {
    return await axiosClient.get(`${resource}/transport?date=${toJSONDate(date)}`)
  },
  async getDietReportDetails (weekNumber: number, year: number) {
    return await axiosClient.get(`${resource}/diet?weekNumber=${weekNumber}&year=${year}`)
  },
  async getSicknessReportDetails (date: Date) {
    return await axiosClient.get(`${resource}/sickness?date=${toJSONDate(date)}`)
  },
  async saveTimeReport (dto: TimeReport) {
    dto.date = toJSONDate(dto.date as Date | string)
    return await axiosClient.post(`${resource}/time`, dto)
  },
  async saveTransportReport (dto: TransportReport) {
    dto.date = toJSONDate(dto.date as Date | string)
    return await axiosClient.post(`${resource}/transport`, dto)
  },
  async saveDietReport (dto: DietReport) {
    return await axiosClient.post(`${resource}/diet`, dto)
  },
  async saveSicknessReport (dto: SicknessReport) {
    dto.date = toJSONDate(dto.date as Date | string)
    return await axiosClient.post(`${resource}/sickness`, dto)
  }
}
